import React from 'react';
import { Select, Spin, Button, Icon, Modal, Form, Input, Row, Col, InputNumber } from 'antd';
import { openNotification } from '../../util/notificaciones';
import EquivalenciaArticuloRequest from '../../services/EquivalenciaArticulo';
import ArticulosRequest from '../../services/Articulos';
import BaseComponent from '../Common/BaseComponent';

const { Option } = Select;
const { confirm } = Modal;
const { Search } = Input;

/**
 * Clase para ver el proceso de formulario de categorizar
 */
class FormEquivalenciaArticulo extends BaseComponent {
    state = {
        arrCategorias: [],
        arrArticulosBusqueda: [],
        guardando: false,
        bloquearBotones: false,
        cancelModalConfirm: false,
        arrTiposModelos: [],
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if (this.props.detalleCategoria !== prevProps.detalleCategoria) {
            if (this.props.detalleCategoria) {
                if (this.props.modo !== 'eliminar') {
                    state.arrArticulosBusqueda.push(this.props.detalleCategoria.articulo);
                    this.setState(state, () => {
                        const { setFieldsValue } = this.props.form
                        setFieldsValue({
                            articulo: this.props?.detalleCategoria?.articulo?.id ?? null
                        })
                    })
                }
            }
        }
    }

    /**
     * Comportamiento al hacer clic en guardar equivalencia
     * @param: nada.
     * @return: nada.
     */
    editarEquivalencia = () => {
        let state = { ...this.state }
        let objEnviar = {}
        let drives = this.props.drives_selected;
        objEnviar.articulo = {}
        this.props.form.validateFields((err, values) => {
            if (!err) {
                objEnviar.id = this.props?.detalleCategoria?.id
                objEnviar.sitios = drives
                objEnviar.multiplo = values.multiplo
                objEnviar.articulo.id = drives?.length > 1 ? this.props.articulo_selected : values.articulo
                this.setState({ guardando: true, bloquearBotones: true }, () => {
                    EquivalenciaArticuloRequest.EditarEquivalencias(objEnviar)
                        .then(response => {
                            state.guardando = false;
                            state.bloquearBotones = false;
                            state.arrArticulosBusqueda = []
                            this.props.form.resetFields();
                            this.props.esconderModal(true);
                            this.setState(state)
                            openNotification(
                                response?.data?.cuerpo,
                                response?.data?.titulo,
                                true
                            )
                        })
                        .catch(err => {
                            this.setState({ guardando: false, bloquearBotones: false })
                            openNotification(
                                err?.response?.data?.cuerpo,
                                err?.response?.data?.titulo,
                                false
                            )
                        })
                })

            }
        })
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de generar un pedido.
     */
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.esconderModal(false);
        this.setState({ bloquearBotones: false, arrArticulosBusqueda: [] })
    }

    /**
     * Comportamiento al confirmar categorización
     * @param: nada.
     * @return: nada.
     */
    showConfirm = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.props.type === 'uno') {
                    confirm({
                        title: 'Confirmar',
                        content: <div><b>¿Está seguro de editar la equivalencia?</b> Se cambiará la información de la equivalencia.</div>,
                        okText: 'Aceptar',
                        cancelText: 'Cancelar',
                        okButtonProps: {
                            id: 'boton-aceptar-confirmacion-equivalencia-form',
                        },
                        cancelButtonProps: {
                            id: 'boton-cancelar-confirmacion-equivalencia-form',
                        },
                        onOk: () => {
                            this.setState({ guardando: true, bloquearBotones: true }, this.editarEquivalencia())
                        },
                    });
                } else {
                    this.setState({ guardando: true, bloquearBotones: true }, this.editarEquivalencia())
                }
            }
        })
    }

    /**
     * Función que se ejecuta cuando se da clic 
     * en buscar en input search
     * @param: value. valor del input search
     * @return: nada.
     */
    buscarArticulo = (value) => {
        let state = { ...this.state }
        let filtros = {}
        if (value.trim()) {
            filtros.filtro = value
            const { setFieldsValue } = this.props.form
            setFieldsValue({
                articulo: null
            })
            this.setState({ cargando: true }, () => {
                ArticulosRequest.ListarArticulos(filtros)
                    .then(response => {
                        state.arrArticulosBusqueda = response.data.results
                        state.cargando = false;
                        this.setState(state)
                        if (!response.data.results.length) openNotification(
                            "No se ha encontrado un artículo con el código / descripción ingresado.",
                            "Verificar búsqueda",
                            false
                        )
                    })
                    .catch(err => {
                        this.setState({ cargando: false })
                        openNotification(err?.response?.data?.cuerpo, err?.response?.data?.cuerpo, false)
                    })
            })
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        let modo = this.props.modo
        let drives = this.props.drives_selected;
        return (
            <div>
                <Modal
                    title={this.props.modo === 'ver' ? 'Ver detalle de equivalencia' : this.props.modo === 'editar' ? 'Editar equivalencia' : 'Nueva equivalencia'}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.categorizarArts}
                    width={this.state.isPos ? "85%" : "35%"}
                    maskClosable={false}
                    confirmLoading={true}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-equivalencia-form"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className={this.props.modo === 'ver' ? 'display-none' : ''}
                                key="submit"
                                id="boton-guardar-equivalencia-form"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={this.showConfirm}
                            >
                                Guardar
                            </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.guardando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Form onSubmit={this.showConfirm}>
                            <Row gutter={12}>
                                <Col className={(this.props.modo === 'ver' || drives?.length > 1) ? 'display-none' : ''} span={24}>
                                    <Form.Item
                                        label={modo === 'ver' ? <b>Buscar artículo por Código / Descripción</b> : 'Buscar artículo por Código / Descripción'}
                                        colon={modo !== 'ver' ? true : false}
                                    >
                                        {getFieldDecorator('buscar_articulo', {
                                            rules: [
                                                { required: false },
                                                { whitespace: true, message: 'Por favor, ingrese Código / Descripción.' }
                                            ]
                                        })(
                                            <Search
                                                className={modo !== 'ver' ? 'btn-buscar-articulo-form' : 'disableInputText'}
                                                disabled={modo !== 'ver' ? false : true}
                                                id="input-search-articulo-equivalencia-form"
                                                placeholder="Ingrese Código / Descripción"
                                                enterButton="Buscar"
                                                onSearch={value => { this.buscarArticulo(value) }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className={(drives?.length > 1) ? 'display-none' : ''} span={24}>
                                    <Form.Item
                                        label={modo === 'ver' ? <b>Artículo</b> : 'Artículo'}
                                        colon={modo !== 'ver' ? true : false}
                                    >
                                        {getFieldDecorator('articulo', {
                                            rules: [
                                                { required: (modo === 'ver' || drives?.length > 1) ? false : true, message: 'Por favor, seleccione un artículo.' },
                                            ],
                                            initialValue: (
                                                this.props?.detalleCategoria?.articulo?.id
                                            )
                                        })(
                                            <Select
                                                allowClear={true}
                                                id="select-articulo-form-articulo-equivalencias"
                                                className={(modo === 'ver' || !this.state.arrArticulosBusqueda?.length) ? 'disableInputText' : ''}
                                                disabled={(modo === 'ver' || !this.state.arrArticulosBusqueda?.length) ? true : false}
                                                defaultActiveFirstOption={false}
                                                style={{ width: "100%" }}
                                                showArrow={modo !== 'ver'}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                            >
                                                <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrArticulosBusqueda?.length > 0 &&
                                                    this.state.arrArticulosBusqueda?.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj?.id}
                                                                value={obj?.id}>
                                                                {obj?.codigo_descripcion}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={modo === 'ver' ? <b>Múltiplo</b> : 'Múltiplo'}
                                        colon={modo !== 'ver' ? true : false}
                                    >
                                        {getFieldDecorator('multiplo', {
                                            rules: [
                                                { required: modo !== 'ver' ? true : false, message: 'Por favor, ingrese una cantidad para múltiplo' }
                                            ],
                                            initialValue: (
                                                this.props?.detalleCategoria?.multiplo
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-multiplo-equivalencia-form"
                                                type="number"
                                                placeholder='Ingrese múltiplo'
                                                className={modo === 'ver' ? 'disableInputText' : ''}
                                                disabled={(modo === 'ver') ? true : false}
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={5}
                                                max={10000}
                                                precision={0}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
            </div >
        )
    }
}

export default Form.create()(FormEquivalenciaArticulo);